module.exports = __webpack_public_path__ + "img/touxiang.4c3fdc7e.png";